import { EntityName, EntityPluralName } from '@enums/EntityName';
import Chip from './Chip';
import entityColor from './utils/entityColor';

const EntityChip = ({
  type,
  expanded = true,
  fontWeight = 700,
  plural,
  ...props
}) => {
  const label = plural
    ? EntityPluralName[type]?.toUpperCase()
    : EntityName[type];
  const chipColor = entityColor(type);

  return (
    <Chip
      colorProps={chipColor}
      expanded={expanded}
      fontWeight={fontWeight}
      name={label}
      {...props}
    />
  );
};

export default EntityChip;
